import React, { useState, useEffect } from 'react';
import { Countdown } from './Countdown.tsx';
import { ScratchCard } from './ScratchCard.tsx';
import { LogoSmall, TwitterIcon, YoutubeIcon, InstagramIcon, SnapchatIcon } from './LandingPageIcons.tsx';
import { Music } from 'lucide-react';
import { toast } from 'sonner';
import imgRectangle955798 from "../../assets/3d128605dddbbbe335f97ad65732133129fa3eb2.png";
import imgBrain from "../../assets/284d48c4e65f65aef87f63fad74274a19653e41c.png";

// export function LandingPage() {
//   const [artistName, setArtistName] = useState('ARTBAT');

//   useEffect(() => {
//     const artists = ['ARTBAT', 'ALAN WALKER', 'ALESSO', 'AMELIE LENS'];
//     const random = artists[Math.floor(Math.random() * artists.length)];
//     setArtistName(random);
//   }, []);

//   return (
//     <div className="loyal-freaks preflight-scope min-h-screen bg-[#625de4] flex flex-col relative overflow-x-hidden font-sans text-black">
//       {/* Top Banner Background */}
//       {/* <div className="absolute top-0 left-0 w-full h-[124px] z-0 pointer-events-none">
//         <img src={imgRectangle955798} alt="" className="w-full h-full object-cover" />
//       </div> */}

//       {/* Header */}
  

//       <main className="flex-grow flex flex-col items-center w-full max-w-[1920px] mx-auto px-4 py-8 md:py-16 relative z-10 gap-16">
        
//         {/* Main Info Card */}
//         <section className="w-full mt-24 max-w-[1140px] px-4">
//           <div className="relative bg-white border-4 border-black rounded-[30px] shadow-[10px_10px_0px_0px_black] p-6 md:p-12 lg:p-16 flex flex-col items-center text-center">
//             <h2 className="font-extrabold text-2xl md:text-3xl lg:text-4xl uppercase mb-8 leading-tight">
//               WELCOME BACK!
//             </h2>
//             <h2 className="font-extrabold text-2xl md:text-3xl lg:text-4xl uppercase mb-8 leading-tight">
//               YOU WERE RIGHT TO SIGN UP EARLY!
//             </h2>
            
//             <div className="max-w-[900px] text-lg md:text-xl leading-relaxed space-y-6">
//               <p>
//                 You trusted Freaks of Nature before there was a lineup, before announcements, before the noise.
//                 We don’t forget that.
//                 So here’s something just for you.
//               </p>
              
//               <h3 className="font-bold text-2xl md:text-3xl uppercase mt-8 mb-4">THIS IS YOUR SECRET GIFT!</h3>
              
//               <p>
//                 As part of our early access list, you’re getting access no one else will.
//               </p>
//               <p>
//                 For the next 7 days only, you can secure your ticket at the lowest price of the entire campaign — a level that will never be available publicly.
//               </p>
//               <p>
//                 A quiet thank you...From us to you.
//               </p>
//               <p className="font-bold uppercase">
//                 15% Discount ON TOP OF EARLY BIRD
//               </p>
//             </div>

//             {/* Lineup Reveal Section (Moved Here) */}
//             <div className="flex flex-col items-center gap-6 mt-12 mb-8 w-full border-t-2 border-dashed border-gray-300 pt-8">
//               <h2 className="font-black text-2xl md:text-3xl uppercase leading-tight">
//                   LINEUP SNEAK PEAK<br/>BEFORE WE TELL THE WORLD, WE TELL YOU.
//               </h2>
//               <p className="text-lg md:text-xl leading-relaxed max-w-[800px]">
//                   The Phase 1 lineup drops Wednesday at 9:00 PM. But because you’re family, we’re letting you see one name early. Just for you. Scratch the card below to reveal one of our Phase 1 headliners.
//               </p>
              
//               {/* Scratch Card */}
//               <div className="relative z-20 mt-2">
//                   <ScratchCard className="w-[300px] md:w-[400px] h-[80px] md:h-[100px] rounded-[10px] overflow-hidden shadow-[5px_5px_0px_0px_black] border-2 border-black bg-[#ED196F]">
//                       <div className="w-full h-full bg-[#ED196F] flex items-center justify-center select-none">
//                           <span className="font-black text-2xl md:text-4xl uppercase text-white tracking-tighter drop-shadow-md">
//                               {artistName}
//                           </span>
//                       </div>
//                   </ScratchCard>
//               </div>
//             </div>

//             {/* Promo Code */}
//             <div className="mt-4 mb-8 flex items-center justify-center gap-4 flex-wrap">
//                 <span className="font-bold text-xl uppercase">PROMO CODE:</span>
//                 <div 
//                     className="relative -rotate-2 cursor-pointer active:scale-95 transition-transform"
//                     onClick={() => {
//                         const textArea = document.createElement("textarea");
//                         textArea.value = 'SIGNUP15';
//                         textArea.style.position = "fixed";
//                         textArea.style.left = "-9999px";
//                         document.body.appendChild(textArea);
//                         textArea.focus();
//                         textArea.select();
//                         try {
//                             const successful = document.execCommand('copy');
//                             if (successful) {
//                                 toast.success('PROMO CODE COPIED!');
//                             } else {
//                                 toast.error('Failed to copy');
//                             }
//                         } catch (err) {
//                             console.error('Copy failed', err);
//                             toast.error('Failed to copy');
//                         }
//                         document.body.removeChild(textArea);
//                     }}
//                     title="Click to copy"
//                 >
//                     <div className="absolute inset-0 bg-black rounded-[10px] translate-x-[4px] translate-y-[4px]"></div>
//                     <div className="relative bg-[#ED196F] border-2 border-black rounded-[10px] px-6 py-2 text-white font-bold text-xl uppercase">
//                         SIGNUP15
//                     </div>
//                 </div>
//             </div>

//             {/* Claim Ticket Button */}
//             <div className="mb-12 w-full max-w-[400px]">
//               <a href="https://nofomo.com/events/freaks-of-nature-e7-freak-yard" target="_blank" rel="noopener noreferrer">
//                 <div className="relative group cursor-pointer w-full">
//                     <div className="absolute inset-0 bg-black rounded-[10px] translate-x-[5px] translate-y-[5px]"></div>
//                     <div className="font-sans  relative bg-[#ffbf00] border-2 border-black rounded-[10px] py-4 px-6 flex items-center justify-center text-black text-lg md:text-xl uppercase text-center group-hover:-translate-y-1 transition-transform group-active:translate-y-0 font-[Roboto] font-normal ! font-black">
//                     CLAIM YOUR TICKET NOW
//                     </div>
//                 </div>
//               </a>
//             </div>

//             {/* Countdown */}
//             <Countdown />
            
//             <h2 className="font-bold text-xl sm:text-2xl uppercase text-center mt-8 tracking-wide">
//                 CAMPAIGN ENDS ON 29TH OF DECEMBER
//             </h2>
//           </div>
//         </section>

//         {/* Character + Speech Bubble Area (Kept Brain, removed Lineup text) */}
//         <section className="flex flex-col items-center w-full max-w-[1140px] text-center px-4 -mb-12 md:-mb-24">
//             <div className="relative w-full max-w-[900px] flex flex-col md:flex-row items-center justify-center mt-4">
//                 {/* Brain Image */}
//                 <div className="relative z-10 w-[320px] md:w-[550px]">
//                    <img 
//                       src={imgBrain} 
//                       alt="Secret Character" 
//                       className="w-full h-auto object-contain translate-y-4 md:translate-y-8" 
//                     />
//                 </div>

//                 {/* Speech Bubble (Empty for now) */}
//                 <div className="relative z-20 mt-[-40px] md:mt-0 md:ml-[-60px] md:mb-[150px]">
                    
//                 </div>
//             </div>
//         </section>

//       </main>

//       {/* New Footer */}
//       <footer className="w-full py-8 px-4 flex justify-center mt-auto relative z-40">
//         <div className="bg-[#ffbf00] w-full max-w-[1000px] rounded-full border-4 border-black shadow-[8px_8px_0px_0px_black] px-6 md:px-10 py-4 flex flex-col md:flex-row items-center justify-between gap-4">
//             <div className="flex flex-col items-center md:items-start leading-none gap-1">
//                 <span className="font-black text-xl md:text-2xl uppercase">2025 FREAKYARD</span>
//                 <span className="font-bold text-xs md:text-sm uppercase tracking-wider opacity-80">Freaks of Nature</span>
//             </div>
            
//             <div className="flex items-center gap-4">
//                 <span className="font-bold uppercase text-sm md:text-base hidden md:inline-block">FOLLOW THE FREAKNESS:</span>
//                 <div className="flex gap-3">
//                      <a href="https://www.instagram.com/werfreaksofnature/" target="_blank" rel="noopener noreferrer" className="bg-white border-2 border-black rounded-full p-2 hover:scale-110 transition-transform flex items-center justify-center w-10 h-10">
//                         <InstagramIcon className="w-5 h-5" />
//                      </a>
//                      <a href="https://x.com/fonfreaks" target="_blank" rel="noopener noreferrer" className="bg-white border-2 border-black rounded-full p-2 hover:scale-110 transition-transform flex items-center justify-center w-10 h-10">
//                         <TwitterIcon className="w-5 h-5" />
//                      </a>
//                      <a href="https://www.youtube.com/@relivefreaksofnature" target="_blank" rel="noopener noreferrer" className="bg-white border-2 border-black rounded-full p-2 hover:scale-110 transition-transform flex items-center justify-center w-10 h-10">
//                         <YoutubeIcon className="w-5 h-5" />
//                      </a>
//                      <a href="https://www.snapchat.com/@s.x777s?invite_id=-9K1rQIn&locale=en_MD&share_id=zqQOpUjEQ26JY7F6453utg&sid=89991500488c45e892a1952c25a9a99a" target="_blank" rel="noopener noreferrer" className="bg-white border-2 border-black rounded-full p-2 hover:scale-110 transition-transform flex items-center justify-center w-10 h-10">
//                         <SnapchatIcon className="w-5 h-5" />
//                      </a>
//                      <a href="https://www.tiktok.com/@wearefreaksofnature" target="_blank" rel="noopener noreferrer" className="bg-white border-2 border-black rounded-full p-2 hover:scale-110 transition-transform flex items-center justify-center w-10 h-10">
//                         <Music className="w-5 h-5" />
//                      </a>
//                 </div>
//             </div>
//         </div>
//       </footer>
//     </div>
//   );
// }


// export function LandingPage() {
//   const [artistName, setArtistName] = useState('ARTBAT');

//   useEffect(() => {
//     const artists = ['ARTBAT', 'ALAN WALKER', 'ALESSO', 'AMELIE LENS'];
//     const random = artists[Math.floor(Math.random() * artists.length)];
//     setArtistName(random);
//   }, []);

//   return (
  
//  <div  className="preflight-scope">
  
//   <div className="loyal-freaks min-h-screen bg-[#625de4] flex flex-col relative overflow-x-hidden text-black">
//         {/* Top Banner Background */}
//         {/* <div className="absolute top-0 left-0 w-full h-[124px] z-0 pointer-events-none">
//           <img src={imgRectangle955798} alt="" className="w-full h-full object-cover" />
//         </div> */}

//         {/* Header */}
      

//         <main className="flex-grow flex flex-col items-center w-full max-w-[1920px] mx-auto px-4 py-8 md:py-16 relative z-10 gap-16">
          
//           {/* Main Info Card */}
//           <section className="w-full mt-24 max-w-[1140px] px-4">
//             <div className="relative bg-white border-4 border-solid border-black rounded-[30px] shadow-[10px_10px_0px_0px_black] p-6 md:p-12 lg:p-16 flex flex-col items-center text-center">
//               <h2 className="font-extrabold text-2xl md:text-3xl lg:text-4xl uppercase mb-8 leading-tight">
//                 WELCOME BACK!
//               </h2>
//               <h2 className="font-extrabold text-2xl md:text-3xl lg:text-4xl uppercase mb-8 leading-tight">
//                 YOU MADE US WHO WE ARE - THIS ONE'S FOR YOU!
//               </h2>
              
//               <div className="max-w-[900px] text-lg md:text-xl leading-relaxed space-y-6">
//                 <p>
//                   You were part of <span className="font-bold">Freaks of Nature</span> before it became a phenomenon. You stood with us when it was just a dream, and your energy built what's coming next.
//                 </p>
                
//                 <h3 className="font-bold text-2xl md:text-3xl uppercase mt-8 mb-4">THIS IS YOUR SECRET GIFT!</h3>
                
//                 <p>
//                   Because you've been part of the journey from the start, you're getting access no one else will.
//                 </p>
//                 <p>
//                   For the next <span className="font-bold">7 days only</span>, you can secure your ticket at the lowest price of the entire campaign — a level that will never be available publicly.
//                 </p>
//                 <p>
//                   A quiet thank you...From us to you.
//                 </p>
//                 <p className="font-bold uppercase">
//                   15% Discount ON TOP OF EARLY BIRD
//                 </p>
//               </div>

//               {/* Lineup Reveal Section (Moved Here) */}
//               <div className="flex flex-col items-center gap-6 mt-12 mb-8 w-full border-t-2 border-dashed border-gray-300 pt-8">
//                 <h2 className="font-black text-2xl md:text-3xl uppercase leading-tight">
//                     LINEUP SNEAK PEAK<br/>BEFORE WE TELL THE WORLD, WE TELL YOU.
//                 </h2>
//                 <p className="text-lg md:text-xl leading-relaxed max-w-[800px]">
//                     The Phase 1 lineup drops Wednesday at 9:00 PM. But because you're family, we're letting you see one name early. Just for you. Scratch the card below to reveal one of our Phase 1 headliners.
//                 </p>
                
//                 {/* Scratch Card */}
//                 <div className="relative z-20 mt-2">
//                     <ScratchCard className="w-[300px] md:w-[400px] h-[80px] md:h-[100px] rounded-[10px] overflow-hidden shadow-[5px_5px_0px_0px_black] border-2 border-solid border-black bg-[#ED196F]">
//                         <div className="w-full h-full bg-[#ED196F] flex items-center justify-center select-none">
//                             <span className="font-black text-2xl md:text-4xl uppercase text-white tracking-tighter drop-shadow-md">
//                                 {artistName}
//                             </span>
//                         </div>
//                     </ScratchCard>
//                 </div>
//               </div>

//               {/* Promo Code */}
//               <div className="mt-4 mb-8 flex items-center justify-center gap-4 flex-wrap">
//                   <span className="font-bold text-xl uppercase">PROMO CODE:</span>
//                   <div 
//                       className="relative -rotate-2 cursor-pointer active:scale-95 transition-transform"
//                       onClick={() => {
//                           const textArea = document.createElement("textarea");
//                           textArea.value = 'RETURN15';
//                           textArea.style.position = "fixed";
//                           textArea.style.left = "-9999px";
//                           document.body.appendChild(textArea);
//                           textArea.focus();
//                           textArea.select();
//                           try {
//                               const successful = document.execCommand('copy');
//                               if (successful) {
//                                   toast.success('PROMO CODE COPIED!');
//                               } else {
//                                   toast.error('Failed to copy');
//                               }
//                           } catch (err) {
//                               console.error('Copy failed', err);
//                               toast.error('Failed to copy');
//                           }
//                           document.body.removeChild(textArea);
//                       }}
//                       title="Click to copy"
//                   >
//                       <div className="absolute inset-0 bg-black rounded-[10px] translate-x-[4px] translate-y-[4px]"></div>
//                       <div className="relative bg-[#ED196F] border-2 border-solid border-black rounded-[10px] px-6 py-2 text-white font-bold text-xl uppercase">
//                           RETURN15
//                       </div>
//                   </div>
//               </div>

//               {/* Claim Ticket Button */}
//               <div className="mb-12 w-full max-w-[400px]">
//                 <a href="https://nofomo.com/events/freaks-of-nature-e7-freak-yard" target="_blank" rel="noopener noreferrer">
//                   <div className="relative group cursor-pointer w-full">
//                       <div className="absolute inset-0 bg-black rounded-[10px] translate-x-[5px] translate-y-[5px]"></div>
//                       <div className="font-sans font-bold relative bg-[#ffbf00] border-2 border-solid border-black rounded-[10px] py-4 px-6 flex items-center justify-center text-black text-lg md:text-xl uppercase text-center group-hover:-translate-y-1 transition-transform group-active:translate-y-0 font-[Roboto] font-normal !font-black">
//                       CLAIM YOUR TICKET NOW
//                       </div>
//                   </div>
//                 </a>
//               </div>

//               {/* Countdown */}
//               <Countdown />
              
//               <h2 className="font-bold text-xl sm:text-2xl uppercase text-center mt-8 tracking-wide">
//                   CAMPAIGN ENDS ON 29TH OF DECEMBER
//               </h2>
//             </div>
//           </section>

//           {/* Character + Speech Bubble Area (Kept Brain, removed Lineup text) */}
//           <section className="flex flex-col items-center w-full max-w-[1140px] text-center px-4 -mb-12 md:-mb-24">
//               <div className="relative w-full max-w-[900px] flex flex-col md:flex-row items-center justify-center mt-4">
//                   {/* Brain Image */}
//                   <div className="relative z-10 w-[320px] md:w-[550px]">
//                     <img 
//                         src={imgBrain} 
//                         alt="Secret Character" 
//                         className="w-full h-auto object-contain translate-y-4 md:translate-y-8" 
//                       />
//                   </div>

//                   {/* Speech Bubble (Empty for now) */}
//                   <div className="relative z-20 mt-[-40px] md:mt-0 md:ml-[-60px] md:mb-[150px]">
                      
//                   </div>
//               </div>
//           </section>

//         </main>

//         {/* New Footer */}
//         <footer className="w-full py-8 px-4 flex justify-center mt-auto relative z-40">
//           <div className="bg-[#ffbf00] w-full max-w-[1000px] rounded-full border-4 border-solid border-black shadow-[8px_8px_0px_0px_black] px-6 md:px-10 py-4 flex flex-col md:flex-row items-center justify-between gap-4">
//               <div className="flex flex-col items-center md:items-start leading-none gap-1">
//                   <span className="font-black text-xl md:text-2xl uppercase">2025 FREAKYARD</span>
//                   <span className="font-bold text-xs md:text-sm uppercase tracking-wider opacity-80">Freaks of Nature</span>
//               </div>
              
//               <div className="flex items-center gap-4">
//                   <span className="font-bold uppercase text-sm md:text-base hidden md:inline-block">FOLLOW THE FREAKNESS:</span>
//                   <div className="flex gap-3">
//                       <a href="https://www.instagram.com/werfreaksofnature/" target="_blank" rel="noopener noreferrer" className="bg-white border-2 border-solid border-black rounded-full p-2 hover:scale-110 transition-transform flex items-center justify-center w-10 h-10">
//                           <InstagramIcon className="w-5 h-5" />
//                       </a>
//                       <a href="https://x.com/fonfreaks" target="_blank" rel="noopener noreferrer" className="bg-white border-2 border-solid border-black rounded-full p-2 hover:scale-110 transition-transform flex items-center justify-center w-10 h-10">
//                           <TwitterIcon className="w-5 h-5" />
//                       </a>
//                       <a href="https://www.youtube.com/@relivefreaksofnature" target="_blank" rel="noopener noreferrer" className="bg-white border-2 border-solid border-black rounded-full p-2 hover:scale-110 transition-transform flex items-center justify-center w-10 h-10">
//                           <YoutubeIcon className="w-5 h-5" />
//                       </a>
//                       <a href="https://www.snapchat.com/@s.x777s?invite_id=-9K1rQIn&locale=en_MD&share_id=zqQOpUjEQ26JY7F6453utg&sid=89991500488c45e892a1952c25a9a99a" target="_blank" rel="noopener noreferrer" className="bg-white border-2 border-solid border-black rounded-full p-2 hover:scale-110 transition-transform flex items-center justify-center w-10 h-10">
//                           <SnapchatIcon className="w-5 h-5" />
//                       </a>
//                       <a href="https://www.tiktok.com/@wearefreaksofnature" target="_blank" rel="noopener noreferrer" className="bg-white border-2 border-solid border-black rounded-full p-2 hover:scale-110 transition-transform flex items-center justify-center w-10 h-10">
//                           <Music className="w-5 h-5" />
//                       </a>
//                   </div>
//               </div>
//           </div>
//         </footer>
//       </div>
//     </div>
//   );
// }


export function LandingPage() {
  const [artistName, setArtistName] = useState('ARTBAT');

  useEffect(() => {
    const artists = ['ARTBAT', 'ALAN WALKER', 'ALESSO', 'AMELIE LENS'];
    const random = artists[Math.floor(Math.random() * artists.length)];
    setArtistName(random);
  }, []);

  return (
  
 <div  className="preflight-scope">

  
  <div className="loyal-freaks !min-h-screen !bg-[#625de4] !flex !flex-col !relative !overflow-x-hidden !text-black">
        {/* Top Banner Background */}
        {/* <div className="absolute top-0 left-0 w-full h-[124px] z-0 pointer-events-none">
          <img src={imgRectangle955798} alt="" className="w-full h-full object-cover" />
        </div> */}

        {/* Header */}
      

        <main className="!flex-grow !flex !flex-col !items-center !w-full !max-w-[1920px] !mx-auto !px-4 !py-8 md:!py-16 !relative !z-10 !gap-16">
          
          {/* Main Info Card */}
          <section className="!w-full !mt-24 !max-w-[1140px] !px-4">
            <div className="!relative !bg-white !border-4 !border-solid !border-black !rounded-[30px] !shadow-[10px_10px_0px_0px_black] !p-6 md:!p-12 lg:!p-16 !flex !flex-col !items-center !text-center">
              <h2 className="!font-extrabold !text-2xl md:!text-3xl lg:!text-4xl !uppercase !mb-8 !leading-tight">
                WELCOME BACK!
              </h2>
              <h2 className="!font-extrabold !text-2xl md:!text-3xl lg:!text-4xl !uppercase !mb-8 !leading-tight">
                YOU MADE US WHO WE ARE - THIS ONE'S FOR YOU!
              </h2>
              
              <div className="!max-w-[900px] !text-lg md:!text-xl !leading-relaxed !space-y-6">
                <p>
                  You were part of <span className="!font-bold">Freaks of Nature</span> before it became a phenomenon. You stood with us when it was just a dream, and your energy built what's coming next.
                </p>
                
                <h3 className="!font-bold !text-2xl md:!text-3xl !uppercase !mt-8 !mb-4">THIS IS YOUR SECRET GIFT!</h3>
                
                <p>
                  Because you've been part of the journey from the start, you're getting access no one else will.
                </p>
                <p>
                  For the next <span className="!font-bold">7 days only</span>, you can secure your ticket at the lowest price of the entire campaign — a level that will never be available publicly.
                </p>
                <p>
                  A quiet thank you...From us to you.
                </p>
                <p className="!font-bold !uppercase">
                  15% Discount ON TOP OF EARLY BIRD
                </p>
              </div>

              {/* Lineup Reveal Section (Moved Here) */}
              <div className="!flex !flex-col !items-center !gap-6 !mt-12 !mb-8 !w-full !border-t-2 !border-dashed !border-gray-300 !pt-8">
                <h2 className="!font-black !text-2xl md:!text-3xl !uppercase !leading-tight">
                    LINEUP SNEAK PEAK<br/>BEFORE WE TELL THE WORLD, WE TELL YOU.
                </h2>
                <p className="!text-lg md:!text-xl !leading-relaxed !max-w-[800px]">
The Phase 1 lineup drops 1st of January, 2026 at 9:00 PM. But because you're family, we're letting you see one name early. Just for you. Scratch the card below to reveal one of our Phase 1 headliners.                </p>
                
                {/* Scratch Card */}
                <div className="!relative !z-20 !mt-2">
                    <ScratchCard className="!w-[300px] md:!w-[400px] !h-[80px] md:!h-[100px] !rounded-[10px] !overflow-hidden !shadow-[5px_5px_0px_0px_black] !border-2 !border-solid !border-black !bg-[#ED196F]">
                        <div className="!w-full !h-full !bg-[#ED196F] !flex !items-center !justify-center !select-none">
                            <span className="!font-black !text-2xl md:!text-4xl !uppercase !text-white !tracking-tighter !drop-shadow-md">
                                {artistName}
                            </span>
                        </div>
                    </ScratchCard>
                </div>
              </div>

              {/* Promo Code */}
              <div className="!mt-4 !mb-8 !flex !items-center !justify-center !gap-4 !flex-wrap">
                  <span className="!font-bold !text-xl !uppercase">PROMO CODE:</span>
                  <div 
                      className="!relative !-rotate-2 !cursor-pointer active:!scale-95 !transition-transform"
                      onClick={() => {
                          const textArea = document.createElement("textarea");
                          textArea.value = 'RETURN15';
                          textArea.style.position = "fixed";
                          textArea.style.left = "-9999px";
                          document.body.appendChild(textArea);
                          textArea.focus();
                          textArea.select();
                          try {
                              const successful = document.execCommand('copy');
                              if (successful) {
                                  toast.success('PROMO CODE COPIED!');
                              } else {
                                  toast.error('Failed to copy');
                              }
                          } catch (err) {
                              console.error('Copy failed', err);
                              toast.error('Failed to copy');
                          }
                          document.body.removeChild(textArea);
                      }}
                      title="Click to copy"
                  >
                      <div className="!absolute !inset-0 !bg-black !rounded-[10px] !translate-x-[4px] !translate-y-[4px]"></div>
                      <div className="!relative !bg-[#ED196F] !border-2 !border-solid !border-black !rounded-[10px] !px-6 !py-2 !text-white !font-bold !text-xl !uppercase">
                          RETURN15
                      </div>
                  </div>
              </div>

              {/* Claim Ticket Button */}
              <div className="!mb-12 !w-full !max-w-[400px]">
                <a href="https://nofomo.com/events/freaks-of-nature-e7-freak-yard" target="_blank" rel="noopener noreferrer">
                  <div className="!relative group !cursor-pointer !w-full">
                      <div className="!absolute !inset-0 !bg-black !rounded-[10px] !translate-x-[5px] !translate-y-[5px]"></div>
                      <div className="!font-sans !font-bold !relative !bg-[#ffbf00] !border-2 !border-solid !border-black !rounded-[10px] !py-4 !px-6 !flex !items-center !justify-center !text-black !text-lg md:!text-xl !uppercase !text-center group-hover:!-translate-y-1 !transition-transform group-active:!translate-y-0 !font-[Roboto] !font-black">
                      CLAIM YOUR TICKET NOW
                      </div>
                  </div>
                </a>
              </div>

              {/* Countdown */}
              <Countdown />
              
              <h2 className="!font-bold !text-xl sm:!text-2xl !uppercase !text-center !mt-8 !tracking-wide">
                  CAMPAIGN ENDS ON 6TH OF JANUARY
              </h2>
            </div>
          </section>

          {/* Character + Speech Bubble Area (Kept Brain, removed Lineup text) */}
          <section className="!flex !flex-col !items-center !w-full !max-w-[1140px] !text-center !px-4 !-mb-12 md:!-mb-24">
              <div className="!relative !w-full !max-w-[900px] !flex !flex-col md:!flex-row !items-center !justify-center !mt-4">
                  {/* Brain Image */}
                  <div className="!relative !z-10 !w-[320px] md:!w-[550px]">
                    <img 
                        src={imgBrain} 
                        alt="Secret Character" 
                        className="!w-full !h-auto !object-contain !translate-y-4 md:!translate-y-8" 
                      />
                  </div>

                  {/* Speech Bubble (Empty for now) */}
                  <div className="!relative !z-20 !mt-[-40px] md:!mt-0 md:!ml-[-60px] md:!mb-[150px]">
                      
                  </div>
              </div>
          </section>

        </main>

        {/* New Footer */}
        <footer className="!w-full !py-8 !px-4 !flex !justify-center !mt-auto !relative !z-40">
          <div className="!bg-[#ffbf00] !w-full !max-w-[1000px] !rounded-full !border-4 !border-solid !border-black !shadow-[8px_8px_0px_0px_black] !px-6 md:!px-10 !py-4 !flex !flex-col md:!flex-row !items-center !justify-between !gap-4">
              <div className="!flex !flex-col !items-center md:!items-start !leading-none !gap-1">
                  <span className="!font-black !text-xl md:!text-2xl !uppercase">2025 FREAKYARD</span>
                  <span className="!font-bold !text-xs md:!text-sm !uppercase !tracking-wider !opacity-80">Freaks of Nature</span>
              </div>
              
              <div className="!flex !items-center !gap-4">
                  <span className="!font-bold !uppercase !text-sm md:!text-base !hidden md:!inline-block">FOLLOW THE FREAKNESS:</span>
                  <div className="!flex !gap-3">
                      <a href="https://www.instagram.com/werfreaksofnature/" target="_blank" rel="noopener noreferrer" className="!bg-white !border-2 !border-solid !border-black !rounded-full !p-2 hover:!scale-110 !transition-transform !flex !items-center !justify-center !w-10 !h-10">
                          <InstagramIcon className="!w-5 !h-5" />
                      </a>
                      <a href="https://x.com/fonfreaks" target="_blank" rel="noopener noreferrer" className="!bg-white !border-2 !border-solid !border-black !rounded-full !p-2 hover:!scale-110 !transition-transform !flex !items-center !justify-center !w-10 !h-10">
                          <TwitterIcon className="!w-5 !h-5" />
                      </a>
                      <a href="https://www.youtube.com/@relivefreaksofnature" target="_blank" rel="noopener noreferrer" className="!bg-white !border-2 !border-solid !border-black !rounded-full !p-2 hover:!scale-110 !transition-transform !flex !items-center !justify-center !w-10 !h-10">
                          <YoutubeIcon className="!w-5 !h-5" />
                      </a>
                      <a href="https://www.snapchat.com/@s.x777s?invite_id=-9K1rQIn&locale=en_MD&share_id=zqQOpUjEQ26JY7F6453utg&sid=89991500488c45e892a1952c25a9a99a" target="_blank" rel="noopener noreferrer" className="!bg-white !border-2 !border-solid !border-black !rounded-full !p-2 hover:!scale-110 !transition-transform !flex !items-center !justify-center !w-10 !h-10">
                          <SnapchatIcon className="!w-5 !h-5" />
                      </a>
                      <a href="https://www.tiktok.com/@wearefreaksofnature" target="_blank" rel="noopener noreferrer" className="!bg-white !border-2 !border-solid !border-black !rounded-full !p-2 hover:!scale-110 !transition-transform !flex !items-center !justify-center !w-10 !h-10">
                          <Music className="!w-5 !h-5" />
                      </a>
                  </div>
              </div>
          </div>
        </footer>
      </div>
    </div>
  );
}